import React from 'react';
import WelcomeBiomercyLoader from './layouts/WelcomeBiomercyLoader';

function App() {
  return <WelcomeBiomercyLoader />;
}

export default App;
